import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AdminModeProvider } from './context/AdminModeContext';
import { CurrentMemorialProvider } from './context/CurrentMemorialContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookieConsentProvider>
      <CurrentMemorialProvider>
        <AdminModeProvider>
          <App />
        </AdminModeProvider>
      </CurrentMemorialProvider>
    </CookieConsentProvider>
  </React.StrictMode>
);
